import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";

const isChrome = () => {
    return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
    );
};

const isDesktop = () => {
    return window.innerWidth > 1000;
};

const ChromeExtension = ({
    extensionId,
    lang,
    installExtensionButton,
    installExtensionMessage,
    closeExtensionMessage,
    enhanceExtensionMessage,
}) => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const alreadyShown = localStorage.getItem("chromeExtensionPopupShown");

        if (isChrome() && isDesktop() && !alreadyShown) {
            setShowPopup(true);
        }
    }, []);

    const handleInstallClick = () => {
        window.open(
            `https://chrome.google.com/webstore/detail/${extensionId}?hl=${lang}`,
            "_blank"
        );
        handleClose();
        // Устанавливаем флаг в sessionStorage
        localStorage.setItem("chromeExtensionPopupShown", "true");
    };

    const handleClose = () => {
        setShowPopup(false);
        localStorage.setItem("chromeExtensionPopupShown", "true");
    };

    if (!showPopup) {
        return null;
    }

    return (
        <div
            className="fixed bottom-0 left-0"
            style={{ marginBottom: "100px", marginLeft: "50px" }}
        >
            <div className="bg-white p-5 rounded-lg shadow-lg">
                <h2 className="text-lg font-bold mb-4">
                    {installExtensionMessage}
                </h2>
                <p className="mb-4">{enhanceExtensionMessage}</p>
                <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
                    onClick={handleInstallClick}
                >
                    {installExtensionButton}
                </button>
                <button
                    className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                    onClick={handleClose}
                >
                    {closeExtensionMessage}
                </button>
            </div>
        </div>
    );
};

if (document.getElementById("chrome-extension-popup")) {
    const container = document.getElementById("chrome-extension-popup");
    const root = createRoot(container);
    root.render(
        <ChromeExtension
            extensionId={container.getAttribute("extensionId")}
            lang={container.getAttribute("lang")}
            installExtensionButton={container.getAttribute(
                "installExtensionButton"
            )}
            installExtensionMessage={container.getAttribute(
                "installExtensionMessage"
            )}
            closeExtensionMessage={container.getAttribute(
                "closeExtensionMessage"
            )}
            enhanceExtensionMessage={container.getAttribute(
                "enhanceExtensionMessage"
            )}
        />
    );
}

export default ChromeExtension;
